
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { OnClickOutside } from "@vueuse/components";
import Ripple from "primevue/ripple";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import OrderDocsModel from "../models/OrderDocsModel";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RouteCardInfo",
  components: {
    Button,
    Skeleton,
    OnClickOutside,
    Toast,
  },
  props: ["order", "guid", "orderId", "mail", "phone", "route", "pnr"],
  setup(props) {
    const toast = useToast();
    const { toClipboard } = useClipboard();
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const orderDocs = ref<OrderDocsModel | null>(null);
    const showSuccess = () => {
      toast.add({
        severity: "success",
        summary: "Скопировано",
        detail: "в буфер обмена",
        life: 3000,
      });
    };
    const getOrderDocs = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPassengers?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        orderDocs.value = fetchedPass;
        console.log(orderDocs.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const copyTicket = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    const copyInsur = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    const copyTaxes = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    return {
      isLoading,
      error,
      orderDocs,
      getOrderDocs,
      copyTicket,
      copyInsur,
      copyTaxes,
    };
  },
  data() {
    return {
      optnInsurOpen: [false, false, false, false, false, false, false, false],
      optnTaxOpen: [false, false, false, false, false, false, false, false],
      optnTicketOpen: [false, false, false, false, false, false, false, false],
      visibleTickets: false,
    };
  },
  methods: {
    getRequesterMail() {
      let mailInfo = sessionStorage.getItem("userName");
      let mail;
      if (mailInfo) {
        mail = JSON.parse(mailInfo);
        return mail;
      } else {
        return "";
      }
    },
    getDotDate(date: any) {
      let dotDate;
      let fullDate = new Date(date);
      let day = fullDate.getDate();
      let month = fullDate.getMonth();
      let fullMonth;
      let year = fullDate.getFullYear();
      if (month < 10) {
        fullMonth = "0" + month;
      } else {
        fullMonth = month;
      }
      dotDate = day + "." + fullMonth + "." + year;
      return dotDate;
    },
    ticketSave(num: any) {
      window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/itinerary`;
    },
    insurSave(url: any) {
      window.location.href = url;
    },
    taxSave(num: any) {
      window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/tax`;
    },
    onClickAwayTicket(index: any) {
      this.optnTicketOpen[index] = false;
    },
    onClickAwayInsur(index: any) {
      this.optnInsurOpen[index] = false;
    },
    onClickAwayTax(index: any) {
      this.optnTaxOpen[index] = false;
    },
    getTicketStatus(state: number) {
      if (state == 10) {
        return "Создан";
      } else if (state == 20) {
        return "Выпущен";
      } else if (state == 30) {
        return "Аннулирован";
      } else if (state == 40) {
        return "Возвращен";
      } else if (state == 50) {
        return "Обменян";
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getOrderDocs();
  },
  directives: {
    ripple: Ripple,
  },
});
